import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { ExamInstanceGradingSummary } from "../../types/grading";

/**
 * Hook for fetching the grading summary of an exam instance.
 * Provides real-time grading progress and pass/fail status.
 */
export const useGetGradingSummary = (examInstanceId: string | undefined, options?: { enabled?: boolean }) => {
  const axios = useAxios();

  return useQuery<ExamInstanceGradingSummary>({
    queryKey: ["gradingSummary", examInstanceId],
    queryFn: async () => {
      const response = await axios.get<ExamInstanceGradingSummary>(
        `/api/grading/examinstances/${examInstanceId}/grading-summary`
      );
      return response.data;
    },
    enabled: !!examInstanceId && (options?.enabled !== false),
    refetchOnWindowFocus: true,
    staleTime: 30000, // 30 seconds
  });
};

export default useGetGradingSummary;
